import MachineryIcon from '../../../../assets/image/category/cars.svg';
import FertilizerIcon from '../../../../assets/image/category/fertilizer.svg';
import ToolIcon from '../../../../assets/image/category/instruments.svg';
import labIcon from '../../../../assets/image/category/laboratory.svg';
import FarmIcon from '../../../../assets/image/category/land.svg';
import PesticideIcon from '../../../../assets/image/category/poison.svg';
import SeedIcon from '../../../../assets/image/category/seed.svg';
import WorkforceIcon from '../../../../assets/image/category/workforce.svg';

export const getInputGroupImage: Record<number, string> = {
  11: FertilizerIcon,
  12: PesticideIcon,
  13: SeedIcon,
  17: FarmIcon,
  16: ToolIcon,
  15: MachineryIcon,
  14: WorkforceIcon,
  18: labIcon,
};

export const getInputGroupRoute: Record<number, string> = {
  11: 'fertilizer',
  12: 'pesticide',
  13: 'seed',
  17: 'farm',
  16: 'tool',
  15: 'machinery',
  14: 'employee',
  18: 'lab',
};

export const getInputGroupCode: Record<string, number> = {
  fertilizer: 11,
  pesticide: 12,
  seed: 13,
  farm: 17,
  tool: 16,
  machinery: 15,
  employee: 14,
  worker: 14,
  lab: 18,
};

export const getInputGroupByCode: Record<number, string> = {
  11: 'کود',
  12: 'سم',
  13: 'بذر و نهال',
  14: 'نیروی کار',
  15: 'ماشین آلات',
  16: 'ابزار و تجهیزات',
  17: 'مزرعه و آب',
  18: 'آزمایشگاه',
};

export const getNameByInputGroup: Record<string, string> = {
  fertilizer: 'کود',
  pesticide: 'سم',
  seed: 'بذر و نهال',
  employee: 'نیروی کار',
  tool: 'ابزار و تجهیزات',
  machinery: 'ماشین آلات',
  farm: 'مزرعه و آب',
  lab: 'آزمایشگاه',
};
